/** This export is automatically generated */
export const isoNow = '2025-06-17T07:40:56.661Z';
